import { SearchTotals } from '../stores/searchStore';

export const ANALYTICS_REPLAY_EVENT = 'analytics-replay';

export enum AnalyticsEventTopic {
    ANALYTICS_CLICK = 'analytics_click',
    ANALYTICS_LOAD_IMPRESSION = 'analytics_load_impression',
    ANALYTICS_CAROUSEL_SHOWN_IMPRESSION = 'analytics_carousel_shown_impression',
    ANALYTICS_CHAT_INIT = 'analytics_chat_init',
    ANALYTICS_SHOWN_IMPRESSION = 'analytics_shown_impression',
    ANALYTICS_PAGE_LOAD = 'analytics_page_load',
    ANALYTICS_AUTHENTICATION = 'analytics_authentication',
    ANALYTICS_SEARCH_DONE = 'analytics_search_done',
    EXPERIMENT_IMPRESSION = 'experiment_impression',
    ANALYTICS_USER_ACTIVITY = 'analytics_user_activity',
    ANALYTICS_USER_INSTALL = 'analytics_user_install',
    ANALYTICS_FILTER_SEARCH = 'analytics_filter_change',
    ANALYTICS_LEAD_EVENT = 'analytics_lead_event',
    ANALYTICS_LIKE_REVIEW = '_likeReview_',
    ANALYTICS_APP_INSTALL = '_AppInstall_',
    ANALYTICS_TEST_DRIVE = '_testDrive_',
    ANALYTICS_AI_OVERVIEW_FEEDBACK = '_aiOverviewFeedback_',
    ANALYTICS_AI_OVERVIEW_SUGGESTED_CLICK = '_aiOverviewSuggestedClick_',
    ANALYTICS_AI_OVERVIEW_CARD_CLICK = '_aiOverviewCardClick_',
    ANALYTICS_FORM_COMPLETION = 'analytics_form_completion',
}

export const AnalyticsEventType = {
    CLICK: 'click',
    TILE_SHOWN: 'tileShown',
    TILE_LOADED: 'tileLoaded',
    SEARCH: 'search',
    IMAGE_SHOWN: 'imageShown',
    CHAT_INIT: 'chatInit',
    FILTER_KEYWORD_CHANGE: 'filterKeywordChange',
    LEAD: 'lead',
    USER_ACTIVITY: 'userActivity',
    USER_INSTALL: 'userInstall',
    AI_OVERVIEW_FEEDBACK: 'aiOverviewFeedback',
    AI_OVERVIEW_SUGGESTED_CLICK: 'aiOverviewSuggestedClick',
    AI_OVERVIEW_CARD_CLICK: 'aiOverviewCardClick',
    FORM_COMPLETION: 'formCompletion',
} as const;

export const createEvent = (eventDetail: any): CustomEvent =>
    new CustomEvent('analytics', {
        composed: true,
        bubbles: true,
        detail: structuredClone(eventDetail),
    });

export const copyEvent = (e: CustomEvent): CustomEvent =>
    new CustomEvent('analytics', {
        composed: true,
        bubbles: true,
        detail: structuredClone(e.detail),
    });

const buildSearchEvent = (
    // @ts-expect-error * Automated Type Error Fix
    section,
    type: string,
    totals?: SearchTotals,
    searchSource?: string,
): CustomEvent => {
    const { totalSearchResults, context } = section;
    return new CustomEvent('analytics', {
        bubbles: true,
        composed: true,
        detail: {
            eventType: 'search',
            topic: AnalyticsEventTopic.ANALYTICS_SEARCH_DONE,
            searchContext: {
                ...context,
                type,
                totals,
                totalSearchResults,
                searchSource,
            },
        },
    });
};

const typeMapping = (type: string): string => {
    const MAPPING = {
        search: 'inspSearch',
        keyword: 'searchboxSubmit',
        filter: 'categoryFacetReload',
    };
    // @ts-expect-error * Automated Type Error Fix
    return MAPPING[type] || type;
};

export const getOafIdFromEvent = (event: any): string => {
    return event.listing?.oafId || event.listing?.external_id || event.oafId || event.external_id;
};

export const ALLOWED_LINKS_AS_TABS = ['more details', 'reviews'];
export const MORE_RESOURCES_EVENT_CONTEXT = 'more resources';
export const SEARCH_RESULT_CLICK_ACTION = 'search_result_click';
export { buildSearchEvent, typeMapping };
